import bidderMeta from '@/router/bidder/bidderMeta.js'

export default [
  {
    path: '/bidder/my-auctions/sidebar',
    name: 'bidder-my-auctions-sidebar',
    redirect: { name: 'bidder-my-auctions-active' },
    meta: {
      ...bidderMeta,
      layout: 'main-sidebar-layout',
    },
    props: {
      title: 'Мои аукционы',
    },
    component: () => import('@/views/Bidder/Sidebar/BidderSidebarMyAuctionsView.vue'),
    children: [
      {
        path: '/bidder/my-auctions/active',
        name: 'bidder-my-auctions-active',
        meta: {
          ...bidderMeta,
          layout: 'main-sidebar-layout',
        },
        component: () => import('@/views/Bidder/MyAuctions/BidderMyAuctionsActiveView.vue'),
      },
      {
        path: '/bidder/my-auctions/archive',
        name: 'bidder-my-auctions-archive',
        meta: {
          ...bidderMeta,
          layout: 'main-sidebar-layout',
        },
        component: () => import('@/views/Bidder/MyAuctions/BidderMyAuctionsArchiveView.vue'),
      },
      {
        path: '/bidder/my-auctions/protocols',
        name: 'bidder-my-auctions-protocols',
        meta: {
          ...bidderMeta,
          layout: 'main-sidebar-layout',
        },
        children: [
          {
            path: '/bidder/my-auctions/protocol/:id',
            name: 'bidder-my-auctions-protocol',
            meta: {
              ...bidderMeta,
              layout: 'main-sidebar-layout',
            },
            component: () =>
              import('@/views/Bidder/MyAuctions/Protocol/BidderMyAuctionsTabsProtocol.vue'),
          },
        ],
        component: () => import('@/views/Bidder/MyAuctions/BidderMyAuctionsProtocolsView.vue'),
      },
    ],
  },
]
